import { Icons } from '@/assets/icons/icons';
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from '@/components/ui/Collapsible';
import { YStack } from '@/components/ui/layout/layout';

import type { MeetingDebugEvent } from '@electron/shared/meeting-debug.types';

function formatTime(epochMs: number): string {
  return new Date(epochMs).toLocaleTimeString('en-US', {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });
}

export function MeetingDebugEventList({
  events,
  emptyLabel,
}: {
  events: MeetingDebugEvent[];
  emptyLabel: string;
}) {
  if (events.length === 0) {
    return <p className="text-xs text-foreground-muted">{emptyLabel}</p>;
  }

  return (
    <YStack role="list" className="gap-0.5">
      {events.map((event, index) => (
        <Collapsible key={`${event.at}-${index}`} role="listitem">
          <CollapsibleTrigger className="flex items-baseline gap-2 w-full py-0.5 text-left group">
            <Icons.chevronRight className="h-3 w-3 shrink-0 text-foreground-muted transition-transform group-data-[state=open]:rotate-90" />
            <span className="text-xs font-mono tabular-nums text-foreground-muted shrink-0">
              {formatTime(event.at)}
            </span>
            <span className="text-[10px] uppercase text-foreground-subtle shrink-0">
              {event.source}
            </span>
            <span className="text-xs text-foreground truncate">
              {event.summary}
            </span>
          </CollapsibleTrigger>
          <CollapsibleContent>
            <pre className="pl-5 text-[10px] font-mono text-foreground-muted whitespace-pre-wrap break-all max-h-[400px] overflow-y-auto">
              {JSON.stringify(event, null, 2)}
            </pre>
          </CollapsibleContent>
        </Collapsible>
      ))}
    </YStack>
  );
}
